import { P0, S, abs, fillAt, max, quad, rotPts } from '../../geometry';

export const pine = {
  name: 'Pine',
  colors: ['#2F9E5B', '#C46A3E'],
  draw(m, t) {
    let A = 2.5,
      sp = 1.3,
      gap = 0,
      wk = 1,
      pose = P0();
    if (m === 'happy') {
      A = 5;
      sp = 7;
      gap = -3 * abs(S(t * 6));
      pose.ty = -2 * abs(S(t * 6));
    }
    // Thinking: a gust keeps running up the tree, each tier swaying a beat after the one below.
    if (m === 'thinking') {
      A = 8;
      sp = 2.6;
    }
    if (m === 'talking') {
      wk = 1 + 0.1 * max(0, S(t * 10));
      A = 1.5;
      sp = 4;
    }
    if (m === 'surprised') {
      gap = -5;
      A = 1;
      sp = 20;
    }
    if (m === 'paused') {
      gap = 3;
      A = 1.5;
      sp = 0.6;
      pose.sy = 0.94;
      pose.ty = 2;
    }
    const tiers = [
      [38, 74, 28],
      [24, 54, 21],
      [11, 36, 15],
    ].map(([ya, yb, w], i) => {
      ya += gap * i * 1.4;
      yb += gap * i * 1.4;
      w *= wk;
      const ang = A * (1 + i * 0.5) * S(t * sp - i * 0.9),
        dx = A * i * 0.5 * S(t * sp - i * 0.9 - 0.6);
      const pts = [
        [50, ya],
        ...quad(
          [50, ya],
          [50 + w * 0.45, (ya + yb) / 2 - 2],
          [50 + w, yb],
          5
        ).slice(1),
        ...quad([50 + w, yb], [50, yb + 3], [50 - w, yb], 5).slice(1),
        ...quad(
          [50 - w, yb],
          [50 - w * 0.45, (ya + yb) / 2 - 2],
          [50, ya],
          5
        ).slice(1),
      ];
      return {
        c: 'a',
        pts: rotPts(pts, 50, yb, ang).map(([x, y]) => [x + dx, y]),
        n: 30,
      };
    });
    return {
      strokes: [
        {
          c: 'b',
          pts: [
            [50, 72],
            [50, 87],
          ],
        },
        ...tiers,
      ],
      eyes: { x: 50, y: 61 },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 1, 2, 3),
};
